import { NAME } from './constants';

export const FETCH_PROPOSAL_CONTENT = `${NAME}/FETCH_PROPOSAL_CONTENT`;
export const FETCH_PROPOSAL_CONTENT_FAILURE = `${NAME}/FETCH_PROPOSAL_CONTENT_FAILURE`;
export const FETCH_PROPOSAL_CONTENT_SUCCESS = `${NAME}/FETCH_PROPOSAL_CONTENT_SUCCESS`;

export const RESET = `${NAME}/RESET`;
